import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-send-mail-cotizacion',
  templateUrl: './send-mail-cotizacion.component.html',
  styles: []
})
export class SendMailCotizacionComponent implements OnInit {

  @Input()
  lead:any=null;
  
  @Input()
  cotizacion:any=null;

  error: any = null;
  sended: boolean = false;

  constructor(
    private api: ApiService,
    public activeModal: NgbActiveModal,
    public spinner: NgxSpinnerService
  ) { 

  }

  ngOnInit() {
    this.sended = false;
    this.lead.email_alt = this.lead.email;
  }

  send(){
    this.error = null;
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.lead.email_alt)){

      this.spinner.show();
    
      let params = {
        lead: this.lead,
        cotizacion: this.cotizacion,
        tipo: 'SEND'
      }
  
      this.api.sendCotizacion(params).subscribe(ret=>{
        this.spinner.hide();
        this.sended = true;
      });
  
    }else{
      if(this.lead.email_alt == ''){
        this.error = 'Debes completar tu email'
      }else{
        this.error = 'El email ingresado no es correcto';
      }
    }

  }



}
